import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/pages/main/task';
import {redeemTask} from '../../../reducers/app/actions';
import Timeout from '../tasks/timeout';
import {useNavigate} from 'react-router-dom';

export default () => {
    const {task, wallet, count} = useSelector(Selector),
          dispatch = useDispatch(),
          navigate = useNavigate();

    // if(wallet.id != "1168949833")
    //     return <></>;

    if(!task || wallet.redflag)
        return <></>;

    

    return (
        <>
            <div className="tasks-list" style={{margin: "20px"}}>
                <div className="task">
                    <div className="task-header">
                        <div className={`icon ${task.icon}`}>
                            {task.icon === "cashouts" && (
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.0333 11.2917C14.6833 11.6334 14.4833 12.125 14.5333 12.65C14.6083 13.55 15.4333 14.2084 16.3333 14.2084H17.9166V15.2C17.9166 16.925 16.5083 18.3334 14.7833 18.3334H6.35831C6.61664 18.1167 6.84164 17.85 7.01664 17.55C7.32498 17.05 7.49998 16.4584 7.49998 15.8334C7.49998 13.9917 6.00831 12.5 4.16665 12.5C3.38331 12.5 2.65831 12.775 2.08331 13.2334V9.59172C2.08331 7.86672 3.49165 6.45837 5.21665 6.45837H14.7833C16.5083 6.45837 17.9166 7.86672 17.9166 9.59172V10.7917H16.2333C15.7666 10.7917 15.3416 10.975 15.0333 11.2917Z" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M2.08331 10.3417V6.53342C2.08331 5.54175 2.69164 4.65838 3.61664 4.30838L10.2333 1.80838C11.2666 1.41672 12.375 2.18341 12.375 3.29174V6.4584" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M18.799 11.6418V13.3586C18.799 13.8169 18.4323 14.1918 17.9657 14.2085H16.3323C15.4323 14.2085 14.6073 13.5502 14.5323 12.6502C14.4823 12.1252 14.6823 11.6335 15.0323 11.2918C15.3407 10.9752 15.7657 10.7919 16.2323 10.7919H17.9657C18.4323 10.8085 18.799 11.1835 18.799 11.6418Z" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M5.83331 10H11.6666" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7.49998 15.8333C7.49998 16.4583 7.32498 17.05 7.01664 17.55C6.84164 17.85 6.61664 18.1167 6.35831 18.3333C5.77498 18.8583 5.00831 19.1667 4.16665 19.1667C2.94998 19.1667 1.89165 18.5167 1.31665 17.55C1.00831 17.05 0.833313 16.4583 0.833313 15.8333C0.833313 14.7833 1.31665 13.8417 2.08331 13.2333C2.65831 12.775 3.38331 12.5 4.16665 12.5C6.00831 12.5 7.49998 13.9917 7.49998 15.8333Z" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M5.40972 15.8163H2.92639" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            )}

                            {task.icon === "deposits" && (
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.5366 12.4208C16.1516 12.7966 15.9316 13.3375 15.9866 13.915C16.0691 14.905 16.9766 15.6291 17.9666 15.6291H19.7083V16.72C19.7083 18.6175 18.1591 20.1666 16.2616 20.1666H6.99412C7.27829 19.9283 7.52579 19.635 7.71829 19.305C8.05746 18.755 8.24996 18.1041 8.24996 17.4166C8.24996 15.3908 6.60913 13.75 4.58329 13.75C3.72163 13.75 2.92413 14.0525 2.29163 14.5566V10.5508C2.29163 8.6533 3.84079 7.10413 5.73829 7.10413H16.2616C18.1591 7.10413 19.7083 8.6533 19.7083 10.5508V11.8708H17.8566C17.3433 11.8708 16.8758 12.0724 16.5366 12.4208Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M2.29163 11.3758V7.1867C2.29163 6.09587 2.96079 5.12416 3.97829 4.73916L11.2566 1.98916C12.3933 1.55833 13.6125 2.40169 13.6125 3.62085V7.10418" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M20.6789 12.8059V14.6943C20.6789 15.1985 20.2755 15.6109 19.7622 15.6293H17.9655C16.9755 15.6293 16.068 14.9051 15.9855 13.9151C15.9305 13.3376 16.1505 12.7968 16.5355 12.4209C16.8747 12.0726 17.3422 11.871 17.8555 11.871H19.7622C20.2755 11.8893 20.6789 12.3018 20.6789 12.8059Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M6.41663 11H12.8333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8.24996 17.4167C8.24996 18.1042 8.05746 18.755 7.71829 19.305C7.52579 19.635 7.27829 19.9283 6.99412 20.1667C6.35246 20.7442 5.50913 21.0833 4.58329 21.0833C3.24496 21.0833 2.08079 20.3683 1.44829 19.305C1.10913 18.755 0.916626 18.1042 0.916626 17.4167C0.916626 16.2617 1.44829 15.2258 2.29163 14.5567C2.92413 14.0525 3.72163 13.75 4.58329 13.75C6.60913 13.75 8.24996 15.3908 8.24996 17.4167Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M5.95066 17.3978H3.21899" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M4.58325 16.0596V18.8004" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            )}
                        </div>

                        <div className="right-block">
                            <div className="task-title">{task.details.name}</div>
                            <div className="task-all" onClick={e => navigate('/tasks')}>
                                See all <span>({count})</span>
                            </div>
                        </div>
                    </div>

                    <div className="task-body">
                        <div className="text">{task.details.text}</div>

                        <div className={`claim ${(!task.completed || task.claimed) ? 'inactive' : ''}`} style={{
                            opacity: task.disabled ? 0.7 : 1,
                            cursor: task.disabled ? 'no-drop' : 'pointer'
                        }} onClick={e => {
                            if(task.claimed || !task.completed)
                                return;

                            if(task.disabled)
                                return;

                            dispatch(redeemTask(task.key));
                        }}>
                            {task.claimed ? (
                                <span><Timeout task_key={task.key} timeout={task.timeout} /></span>
                            ) : (
                                <>
                                    Claim <span>${task.bonus}</span>
                                </>
                            )}
                        </div>
                    </div>

                    <div className="progress">
                        <div className="line">
                            <div className="line-progress" style={{width: `${task.progress.percent}%`}}></div>
                        </div>
                        <div className="ticks">
                            <div className={`tick active`}>
                                <div className="line" style={{opacity: 0}}></div>
                                <div className="value">{task.progress.alias ? task.progress.alias.from : task.progress.from}</div>
                            </div>


                            {(task.progress.percent > 12 && task.progress.percent < 100) && (
                                <div className={`tick active`} style={{
                                    marginLeft: `calc(((100vw - 80px) * ${task.progress.percent / 100} - 20px)`
                                }}>
                                    <div className="line"></div>
                                    <div className="value">{task.progress.alias ? task.progress.alias.current : task.progress.current}</div>
                                </div>
                            )}

                            <div className={`tick ${task.complete ? 'active' : ''}`} style={{marginLeft: `calc(100vw - 80px - 20px)`}}>
                                <div className="line" style={{opacity: 0}}></div>
                                <div className="value">{task.progress.alias ? task.progress.alias.to : task.progress.to}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}